import config from "config/config";
import { getImage } from "js/utilities";
import GenericError from "components/GenericError";
import { useTranslation } from "react-i18next";

const Error = (props) => {
  const { t } = useTranslation();
  const { error, isAgentPortal } = props;

  const headerText = isAgentPortal
    ? t("AuthHeader-title")
    : t("Header-customerTitle");

  return (
    <div className="font-body text-theme-text-primary flex flex-col min-h-screen">
      <div className="flex p-4 items-center">
        <a href="/">
          <img
            className="ui-logo-header"
            src={getImage("logo_blue.png")}
            alt={`${config.COMPANY_NAME} Logo`}
          />
        </a>
        <h2 className="ml-6 pl-6 border-l border-ui-gray-medium-light mb-0 font-semibold text-base font-body text-theme-primary">
          {headerText}
        </h2>
      </div>
      <div className="flex justify-center h-screen">
        <div className="mt-24 md:mt-36 lg:mt-44">
          <GenericError error={error} />
        </div>
      </div>
    </div>
  );
};

export default Error;
